
import React from 'react';
import { NavLink } from 'react-router-dom';
import { useAuth } from '@/contexts/AuthContext';
import { cn } from '@/lib/utils';
import { 
  Users, 
  Briefcase, 
  Calendar, 
  UserPlus,
  Sparkles
} from 'lucide-react';

interface NavLinkItemProps {
  to: string;
  icon: React.ReactNode;
  text: string;
}

const NavLinkItem: React.FC<NavLinkItemProps> = ({ to, icon, text }) => (
  <NavLink 
    to={to}
    className={({ isActive }) => cn(
      "flex items-center space-x-2 px-3 py-2 rounded-md text-sm transition-colors",
      isActive 
        ? "bg-primary/10 text-primary font-medium" 
        : "hover:bg-muted"
    )}
  >
    {icon}
    <span>{text}</span>
  </NavLink>
);

export const NavLinks: React.FC = () => {
  const { user } = useAuth();

  if (!user) {
    // Links for non-authenticated users
    return (
      <div className="flex items-center space-x-6">
        {/* Home navigation link removed */}
      </div>
    );
  }

  // Links for authenticated users
  return (
    <div className="flex items-center space-x-6">
      <NavLinkItem to="/dashboard" icon={<Users className="w-4 h-4" />} text="Dashboard" />
      <NavLinkItem to="/clubs" icon={<Users className="w-4 h-4" />} text="Clubs" />
      <NavLinkItem to="/opportunities" icon={<Briefcase className="w-4 h-4" />} text="Opportunities" />
      <NavLinkItem to="/events" icon={<Calendar className="w-4 h-4" />} text="Events" />
      <NavLinkItem to="/mentors" icon={<UserPlus className="w-4 h-4" />} text="Mentors" />
      <NavLinkItem to="/pitch-playground" icon={<Sparkles className="w-4 h-4" />} text="Pitch Ideas" />
    </div>
  );
};
